import React, { useContext } from 'react';
import { AppContext } from '../../../../contexts/AppContext';
import useEventRepresentationService from '../../../../app/services/intranet_admin/hooks/useEventRepresentationService';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import ActiveControl from '../../../../components/ActiveControl';

interface Props {
    representationId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const EventRepresentationSwitchChange = ({ representationId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { activeRepresentation } = useEventRepresentationService();

    const handleChange = (checked: boolean) => {
        if (showLoading) showLoading('loading', 'Actualizando estado...');

        activeRepresentation(representationId, checked, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return (
        <ActiveControl 
            status={checkValue} 
            id={representationId} 
            callback={handleChange} 
        />
    );
};

export default EventRepresentationSwitchChange; 